<template>
    <div>
        <GmapMap
            :center="mapCenter"
            :zoom="mapZoom"
            :map-type-id="mapType"
            :options="mapOptions"
            class="gmap"
            ref="gmap"
        >
            <GmapCluster ref="cluster"
                         :styles="clusterStyles"
                         :zoom-on-click="true"
                         :grid-size="20">
                <GmapMarker
                    :key="index"
                    v-for="(m, index) in mapMarkers"
                    :position="m.position"
                    :icon="m.icon"
                    :clickable="true"
                    :draggable="false"
                    :title="m.title"
                    @click="markerClicked(index)"
                >
                    <gmap-info-window :opened="infoWindow === `info-window-${ index }`"
                                      class="info-window"
                                      @closeclick="infoWindow = ''">
                        <div class="flex flex-col">
                            <div class="text-xl">{{ m.title }}</div>
                            <div class="my-1" v-html="m.address"></div>
                            <a :href="m.url" class="link self-start mt-2 font-semibold">Meer info</a>
                        </div>
                    </gmap-info-window>
                </GmapMarker>
            </GmapCluster>
        </GmapMap>
    </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';

window.axios = axios

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBR8aL1BmtxtDwv2HwtWLx8v9iC1F0Rgfo',
        libraries: 'places'
    },
    installComponents: true
});

Vue.component('GmapCluster', GmapCluster);

export default {

    data() {
        return {
            mapMarkers: [],
            mapCenter: { lat: 50.855024, lng: 4.3402849 }, // Brussels
            mapZoom: 8,
            mapType: 'roadmap',
            mapOptions: {
                backgroundColor: '#f8f8fc',
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                scaleControl: true,
                zoomControl: true,
                minZoom: 2,
                restriction: {
                    latLngBounds: {
                        north: 80,
                        south: -80,
                        west: -179,
                        east: 179
                    },
                    strictBounds: true
                },
                styles: [
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e9e9e9"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 18
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dedede"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "saturation": 36
                            },
                            {
                                "color": "#333333"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    }
                ]
            },
            clusterStyles: [
                {
                    textColor: '#ffffff',
                    textSize: 15,
                    url: '/assets/img/map-cluster.png',
                    height: 46,
                    width: 46
                }
            ],
            infoWindow: '',
            stores: [],
            near: '',
            loading: false
        }
    },
    methods: {
        loadMarkers() {
            this.loading = true;
            window.axios.get('/api/events.json')
                .then(result => {
                    this.loading = false;
                    if (result.status === 200 && result['data']) {
                        // entries zonder gekoppelde locatie kunnen niet op de kaart
                        this.events = result.data.data.filter(event => event.location);
                        this.loadMapMarkers();
                    } else {
                        console.log('ERROR loading events', result);
                    }
                })
                .catch(error => console.log(error));
        },
        loadMapMarkers() {
            this.mapMarkers = this.events.map(event => {
                return {
                    'position': { 'lat': parseFloat(event.location.lat), 'lng': parseFloat(event.location.lng) },
                    'title': event.title,
                    'address': `${ event.location.parts.address } ${ event.location.parts.number } <br /> ${ event.location.parts.postcode } ${ event.location.parts.city }`,
                    'url': event.url,
                    'icon': event.type === 'radioReveilCafe' ? '/assets/img/map-marker-radio-reveil-cafe.png' : '/assets/img/map-marker.png'
                };
            });
            this.repaintClusters();
        },
        markerClicked(index) {
            this.infoWindow = `info-window-${ index }`;
        },
        zoomMap(zipcode, city) {
            this.loading = true

            var action = '/api/latlong.json'
            var csrfToken = document.head.querySelector('meta[name="csrf-token"]').content
            var formData = new FormData()

            formData.set('CRAFT_CSRF_TOKEN', csrfToken)
            formData.set('zipcode', zipcode)
            formData.set('city', city)

            window.axios({
                method: 'post',
                headers: {
                    "Content-Type": 'application/x-www-form-urlencoded',
                },
                data: formData,
                url: action
            }).then((response) => {
                if(response.status === 200 && response['data']) {
                    this.mapCenter.lat = parseFloat(response.data.lat);
                    this.mapCenter.lng = parseFloat(response.data.lng);
                    this.mapZoom = 12;
                    this.repaintClusters();
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        // MarkerClusterer houdt soms de clusters van het startzoomniveau vast wanneer de
        // markers en de zoom naar een gezochte gemeente tegelijk binnenkomen: dan blijft
        // bv. een cluster "6" staan op zoom 12 en lijkt een gemeente niet op de kaart te staan.
        repaintClusters() {
            this.$nextTick(() => {
                this.$refs.gmap.$mapPromise.then(map => {
                    const repaint = () => {
                        const cluster = this.$refs.cluster && this.$refs.cluster.$clusterObject;
                        if (cluster) {
                            cluster.repaint();
                        }
                    };
                    // markers komen asynchroon bij de clusterer: herteken na een korte pauze
                    // en opnieuw zodra de kaart na het zoomen stilstaat
                    setTimeout(repaint, 300);
                    window.google.maps.event.addListenerOnce(map, 'idle', repaint);
                });
            });
        }
    },
    mounted() {
        var urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('postcode') !== null && urlParams.get('stad') !== null && urlParams.get('postcode') != '' && urlParams.get('stad') != '') {
            this.zoomMap(urlParams.get('postcode'), urlParams.get('stad'));
        }
        this.loadMarkers();
    }
}
</script>